import { render, staticRenderFns } from "./AdminVectorCollections.vue?vue&type=template&id=6c4717ec&"
import script from "./AdminVectorCollections.vue?vue&type=script&lang=js&"
export * from "./AdminVectorCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports